import React, { useState, useEffect } from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import FeedbackForm from './components/FeedbackForm';
import BlockedMessages from './components/BlockedMessages';
import ScoredFeedback from './components/ScoredFeedback';
import ThemeToggle from './components/ThemeToggle';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // Check URL hash and pathname for routing
    const rawHash = window.location.hash.substring(1);
    const hash = rawHash.startsWith('/') ? rawHash.substring(1) : rawHash; // support both #scored and #/scored
    const pathname = window.location.pathname;
    
    console.log('Current hash:', hash);
    console.log('Current pathname:', pathname);
    
    if (hash === 'blocked' || pathname === '/blocked') {
      setCurrentPage('blocked');
      // If accessing /blocked, redirect to /#blocked
      if (pathname === '/blocked') {
        window.history.replaceState(null, '', '/#blocked');
      }
    } else if (hash === 'scored' || pathname === '/scored') {
      setCurrentPage('scored');
      if (pathname === '/scored') {
        window.history.replaceState(null, '', '/#scored');
      }
    } else {
      setCurrentPage('home');
    }

    // Listen for hash changes
    const handleHashChange = () => {
      const rawNewHash = window.location.hash.substring(1);
      const newHash = rawNewHash.startsWith('/') ? rawNewHash.substring(1) : rawNewHash;
      console.log('Hash changed to:', newHash);
      if (newHash === 'blocked') {
        setCurrentPage('blocked');
      } else if (newHash === 'scored') {
        setCurrentPage('scored');
      } else {
        setCurrentPage('home');
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        <ThemeToggle />
        {currentPage === 'home' ? (
          <>
            <header className="App-header">
              <h1>Live Audience Feedback Wall</h1>
              <p>Share your thoughts and questions in real-time!</p>
            </header>
            <main className="App-main">
              <FeedbackForm />
            </main>
          </>
        ) : currentPage === 'blocked' ? (
          <div className="blocked-page-container">
            <BlockedMessages />
          </div>
        ) : (
          <div className="blocked-page-container">
            <ScoredFeedback />
          </div>
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
